import './bar_loader.css';

export const BarLoader = () => {
    return (
        <div className='bar_loader'></div>
    );
}